// @flow
import React, { type Element } from 'react';
import { find, get, filter } from 'lodash';
import { Track } from 'angieslist-app-platform';
import { RatingDisplay, Input } from 'angieslist-react-components';
import type { MetricCategory } from '../../../types';
import './ratingFilter.scss';


const filters = [
  { value: 5 },
  { value: 4 },
  { value: 3 },
  { value: 2 },
  { value: 1 },
];

type Props = {
  categories: MetricCategory[],
  categoryId: number,
  serviceProviderId: string,
  onSelect: (value: number[]) => any,
  starRatingFilters: number[],
};

const RatingFilterComponent = ({
  categories,
  categoryId,
  serviceProviderId,
  onSelect,
  starRatingFilters,
}: Props): Element<"section"> => {
  const counts = get(find(categories, { id: categoryId }), 'reviewMetrics.starRatingCounts', []);
  return (
    <section className="store-review_filters-pane">
      <h3 id="review-tab-header">Ratings:</h3>
      <ul role="navigation" id="review-tab-ratings-list">
        {filters.map(({ value }) => {
          const count = get(find(counts, { starRating: value }), 'count', 0);
          const isSelected = starRatingFilters.indexOf(value) > -1;
          return (
            <li data-disabled={count === 0} key={value}>
              <div style={{ display: 'flex' }}>
                <Track>
                  <Input
                    {...{ value }}
                    id={`review-tab-star-rating-filter-${value}`}
                    data-track-categoryid-id={categoryId}
                    data-track-spid={serviceProviderId}
                    data-track-review-count={count}
                    data-track-filter-state={!isSelected ? 'selected' : 'deselected'}
                    data-track-filter-name={`starRating (${value})`}
                    label=" "
                    disabled={count === 0}
                    checked={isSelected}
                    type="checkbox"
                    name="starRating"
                    onChange={() => {
                    const analyticsProps = isSelected ?
                      filter(starRatingFilters, ratingFilter => ratingFilter !== value) :
                      [...starRatingFilters, value];
                    onSelect(analyticsProps);
                  }}
                  />
                </Track>
                <div style={{ paddingTop: '0.6em' }}>
                  <RatingDisplay
                    rating={value}
                    reviewCountNumberOnly
                    starSize="0.8em"
                    ratingFontSize="0.8em"
                  />
                </div>
                <p style={{
                  paddingLeft: '0.3em',
                  paddingTop: '0.6em',
                   }}
                >({count})
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default RatingFilterComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/RatingFilter.js